/**
 * @generated SignedSource<<cadf7da6c8a25f7a29d3ea6b80d6cbcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type MarkDefragValueKnobsAsPresentedMutationInput = {
  clientMutationId?: string | null;
  knobUrns: ReadonlyArray<UrnInput | null>;
  orgRelayId: string;
};
export type UrnInput = {
  id: string;
  scope?: UrnInput | null;
  type?: UrnType | null;
  value?: string | null;
};
export type MarkDefragValueKnobsAsPresentedMutation$variables = {
  input: MarkDefragValueKnobsAsPresentedMutationInput;
};
export type MarkDefragValueKnobsAsPresentedMutation$data = {
  readonly markDefragValueKnobsAsPresented: {
    readonly clientMutationId: string | null;
  } | null;
};
export type MarkDefragValueKnobsAsPresentedMutation = {
  variables: MarkDefragValueKnobsAsPresentedMutation$variables;
  response: MarkDefragValueKnobsAsPresentedMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkDefragValueKnobsAsPresentedMutationPayload",
    "kind": "LinkedField",
    "name": "markDefragValueKnobsAsPresented",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkDefragValueKnobsAsPresentedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkDefragValueKnobsAsPresentedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4fd9a3a5f772f31b18e46968c6a508b8",
    "id": null,
    "metadata": {},
    "name": "MarkDefragValueKnobsAsPresentedMutation",
    "operationKind": "mutation",
    "text": "mutation MarkDefragValueKnobsAsPresentedMutation(\n  $input: MarkDefragValueKnobsAsPresentedMutationInput!\n) {\n  markDefragValueKnobsAsPresented(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "796e601f8574fd2b5f22da4bfe9a54f0";

export default node;
